import { PHONEME_GUIDE } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/pianoRoll/phonemes/guide/constants";
import type { PhonemeGuideEntry } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/pianoRoll/phonemes/types";

// The guide's view of a phoneme label as typed or stored — case and stray whitespace forgiven, since labels arrive lowercased from the dictionary but a user may type "UW". Null for anything the guide has no word for (a typo, or a symbol the dictionary knows but the guide does not).
export const getPhonemeGuideEntry = (
  phonemeText: string
): PhonemeGuideEntry | null =>
  PHONEME_GUIDE[phonemeText.trim().toLowerCase()] ?? null;
